<template>
    <div :class="classes[$props.type].root"
         class="rounded-lg p-4 ring-2"
    >
        <div class="flex">
            <div class="shrink-0">
                <!-- Heroicon name: mini/information-circle -->
                <svg v-if="$props.type === 'information'"
                     aria-hidden="true"
                     class="h-5 w-5 text-brand-400"
                     fill="currentColor"
                     viewBox="0 0 20 20"
                     xmlns="http://www.w3.org/2000/svg"
                >
                    <path clip-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z"
                          fill-rule="evenodd"
                    />
                </svg>

                <!-- Heroicon name: mini/check-circle -->
                <svg v-else-if="$props.type === 'success'"
                     aria-hidden="true"
                     class="h-5 w-5 text-green-400"
                     fill="currentColor"
                     viewBox="0 0 20 20"
                     xmlns="http://www.w3.org/2000/svg"
                >
                    <path clip-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                          fill-rule="evenodd"
                    />
                </svg>

                <!-- Heroicon name: mini/exclamation-triangle -->
                <svg v-else-if="$props.type === 'warning'"
                     aria-hidden="true"
                     class="h-5 w-5 text-yellow-400"
                     fill="currentColor"
                     viewBox="0 0 20 20"
                     xmlns="http://www.w3.org/2000/svg"
                >
                    <path clip-rule="evenodd"
                          d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                          fill-rule="evenodd"
                    />
                </svg>

                <!-- Heroicon name: mini/x-circle -->
                <svg v-else-if="$props.type === 'error'"
                     aria-hidden="true"
                     class="h-5 w-5 text-red-400"
                     fill="currentColor"
                     viewBox="0 0 20 20"
                     xmlns="http://www.w3.org/2000/svg"
                >
                    <path clip-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
                          fill-rule="evenodd"
                    />
                </svg>
            </div>

            <div :class="classes[$props.type].body">
                <h3 v-if="$slots['heading']"
                    :class="classes[$props.type].heading"
                    class="text-base font-medium mb-4"
                >
                    <slot name="heading" />
                </h3>

                <slot />

                <div v-if="$slots['actions']"
                     :class="classes[$props.type].actions"
                     class="mt-4"
                >
                    <div class="flex space-x-3">
                        <slot name="actions" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            required: true,
            type:     String,
        },
    },

    computed: {
        classes: function () {
            return {
                information: {
                    root:    'bg-brand-50 ring-brand-500',
                    heading: 'text-brand-700',
                    body:    'ml-3 text-brand-700',
                    actions: '',
                },

                success: {
                    root:    'bg-green-50 ring-green-500',
                    heading: 'text-green-800',
                    body:    'ml-3 text-green-700',
                    actions: '',
                },

                warning: {
                    root:    'bg-yellow-50 ring-yellow-500',
                    heading: 'text-yellow-800',
                    body:    'ml-3 text-yellow-700',
                    actions: '',
                },

                error: {
                    root:    'bg-red-50 ring-red-500',
                    heading: 'text-red-800',
                    body:    'ml-3 text-red-700',
                    actions: '',
                },

                promotion: {
                    root:    'bg-linear-to-r from-yellow-300 via-yellow-300 to-yellow-400 ring-yellow-900',
                    heading: 'text-yellow-900',
                    body:    'text-yellow-800 flex-1 md:flex md:justify-between text-sm font-medium',
                    actions: 'text-sm md:ml-6 md:mt-0',
                },
            };
        },
    },
};
</script>
